<template>
  <form ref="shipmentForm">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <!-- Reference -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="reference">Reference</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="reference"
                  required
                  id="reference"
                  placeholder="Enter Reference Number"
                />
              </div>
            </div>
          </div>

          <!-- Loading Date -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="loadingDate">Loading Date</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="loadingDate"
                  required
                  id="loadingDate"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- ETA -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="eta">ETA</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="eta"
                  required
                  id="eta"
                />
              </div>
            </div>
          </div>

          <!-- Departure Date -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="departureDate">Departure Date</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="departureDate"
                  required
                  id="departureDate"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="vesselName">Vessel Name</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="vesselName"
                  required
                  id="vesselName"
                  placeholder="Enter Vessel Name"
                />
              </div>
            </div>
          </div>

          <!-- Point of Arrival -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="pointOfArrival">Point of Arrival</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="pointOfArrival"
                  required
                  id="pointOfArrival"
                  placeholder="Enter Point of Arrival"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import Dropdown from "../AddDispatch/Dropdown.vue";

export default {
  components: { Dropdown },
  name: "ShipmentDetails",
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      reference: this.initialValues?.reference ?? "",
      loadingDate: this.initialValues?.loadingDate ?? "",
      eta: this.initialValues?.eta ?? "",
      departureDate: this.initialValues?.departureDate ?? "",
      vesselName: this.initialValues?.vesselName ?? "",
      pointOfArrival: this.initialValues?.pointOfArrival ?? "",
      showError: false,
    };
  },
  methods: {
    validateForm() {
      const form = this.$refs.shipmentForm;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        reference: this.reference,
        loadingDate: this.loadingDate,
        eta: this.eta,
        departureDate: this.departureDate,
        vesselName: this.vesselName,
        pointOfArrival: this.pointOfArrival
      };
    },
  },
  watch: {
    initialValues: {
      handler(newValues) {
        if (newValues.reference) {
          this.reference = newValues.reference || "";
          this.loadingDate = newValues.loadingDate || "";
          this.eta = newValues.eta || "";
          this.departureDate = newValues.departureDate || "";
          this.vesselName = newValues.vesselName || "";
          this.pointOfArrival = newValues.pointOfArrival || "";
        }
      },
      deep: true,
    },
  },
};
</script>
